// src/components/ui/Title.jsx
import React from "react";

export default function Title({ children }) {
  return (
    <h2 className="text-3xl font-semibold text-text-heading mb-4">
      {children}
    </h2>
  );
}